export enum ERRORS {
  NETWORK,
  SERVER, // http status code from range 50x
  UNAUTHORIZED, // http status code 401
  TECHNICAL_DIFFICULTIES, // http status code from range 40x (except 401)
  SERVER_RETRY, // status error in response, user can retry
}

export const LOG_LEVELS = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  DEBUG: 'DEBUG',
  INFO: 'INFO',
}

export const CLIENT_SCORING_ERRORS = {
  SERVER_ERROR: 'SERVER_ERROR',
  TIMEOUTED: 'TIMEOUTED',
  NOK: 'NOK',
}

export const SEND_SMS_ERRORS = {
  UNKNOWN: 'UNKNOWN',
  NETWORK: 'NETWORK',
  VALIDATIONS: 'VALIDATIONS',
  SERVER: 'SERVER',
}
